import { IForm } from '@/components/types'
import dayjs from 'dayjs'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          const minDate = dayjs('2026-01-01').startOf('day')
          const today = dayjs().startOf('day')
          const selectedDate = dayjs(date).startOf('day')

          return selectedDate.isBefore(minDate) || selectedDate.isAfter(today)
        }
      }
    },
    {
      field: 'deptName',
      type: 'select',
      label: '组别',
      clearable: true,
      filterable: true,
      placeholder: '请选择组别',
      options: []
    },
    {
      field: 'empName',
      type: 'input',
      label: '业务员姓名',
      clearable: true,
      placeholder: '请输入业务员姓名'
    }
  ]
}
